/**
 * App Analytics MV2 query API — isolated from MV1 pages/AppAnalytics.jsx.
 */
import { getAppAnalytics } from "@/lib/api";

export const APP_ANALYTICS_QUERY_KEY = "app-analytics";

export async function fetchAppAnalyticsFromApi(period, signal) {
  const response = await getAppAnalytics(period);
  if (signal?.aborted) throw new DOMException("Aborted", "AbortError");
  return response.data;
}

export function mapAppAnalyticsError(err) {
  if (!err) return "";
  return err?.response?.data?.detail || err?.message || "Could not load App Analytics";
}
